import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { useExtras } from "../../hooks/useExtras";
import ObjDisplay from "../objDisplay/objDisplay";

const ExtraForm = ({ initialData, onSubmit, onDelete }) => {
  const defaultData = { amount: 0, paid: 0, payment: {}, name: "" };

  const [newData, setNewData] = useState({...defaultData, ...initialData});
  const [selectedExtra, setSelectedExtra] = useState(null);
  const [numUnits, setNumUnits] = useState(1);
  const [pricePerUnit, setPricePerUnit] = useState(initialData?.amount || 0);
  const [creatingNewExtra, setCreatingNewExtra] = useState(false);
  const [newExtraName, setNewExtraName] = useState("");

  const { retrieveExtras } = useExtras();

  console.log("ExtraForm initialData:", initialData);
  console.log("ExtraForm newData:", newData);

  const {
    data: extras,
    isLoading: extrasIsLoading,
    error: extrasError,
  } = useQuery("extras", retrieveExtras, {
    staleTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 60,
  });

  // When an extra is selected, load its default price
  useEffect(() => {
    if (selectedExtra) {
      const foundExtra = extras?.find((e) => e.name === selectedExtra);
      if (foundExtra) {
        setPricePerUnit(foundExtra.price || 0);
        setNewData((prev) => ({
          ...prev,
          name: foundExtra.name
        }));
      } 
    }
  }, [selectedExtra, extras]);

  // Update amount when gallons or price changes
  useEffect(() => {
    setNewData((prev) => ({
      ...prev,
      amount: parseFloat((numUnits * pricePerUnit).toFixed(2)),
    }));
  }, [numUnits, pricePerUnit]);

  // useEffect(() => {
  //   if (initialData) {
  //     setNewData(initialData);
  //     if (extras?.some((e) => e.name === initialData.name)) {
  //       setSelectedExtra(initialData.name);
  //     } else if (initialData.name) {
  //       setSelectedExtra("new");
  //       setCreatingNewExtra(true);
  //       setNewExtraName(initialData.name);
  //       setPricePerUnit(initialData.amount || 0);
  //       setNumUnits(1);
  //     } else {
  //       setCreatingNewExtra(false);
  //       setSelectedExtra(null);
  //     }   
  //   } 
  // }, [initialData, defaultData, extras]);

        

  const onChange = (field, value, isPayment = false) => {
    if (isPayment) {
      setNewData((prev) => ({
        ...prev,
        payment: {
          ...(prev.payment || {}),
          [field]: value,
        },
      }));
    } else {
      setNewData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    if (creatingNewExtra) {
      onSubmit({
        ...newData,
        name: newExtraName.trim(),
      });
    } else {
      onSubmit({ ...newData });
    }
  };

  const reset = (e) => {
    e.preventDefault();
    setNewData(initialData || defaultData);
    setNumUnits(1);
  };

  const remove = (e) => {
    e.preventDefault();
    onDelete(newData.name);
  }

  return (
    <form className="p-3 border rounded">
      {/* Extras Dropdown */}
      <div className="mb-3">
        {/* <label className="form-label">Extra</label> */}
        <select
          className="form-control"
          disabled={initialData?.name}
          value={initialData?.name || selectedExtra || ""}
          onChange={(e) => {
            const val = e.target.value;
            if (val === "new") {
              setSelectedExtra("new");
              setCreatingNewExtra(true);
            } else {
              setCreatingNewExtra(false);
              setNewExtraName("");
              setSelectedExtra(val);
            }
          }}
        >
          {initialData?.name && (
            <option value={initialData.name}>{initialData.name} (current)</option>
          )}
          <option value="">Select Payment Name</option>
          {extras?.map((extra) => (
            <option key={extra.name} value={extra.name}>
              {extra.name}
            </option>
          ))}
          <option value="new">Custom Payment</option>
        </select>
      </div>

      {creatingNewExtra && (
        <div className="mb-3">
          <label className="form-label">New Extra Name</label>
          <input
            type="text"
            className="form-control"
            value={newExtraName}
            onChange={(e) => setNewExtraName(e.target.value)}
          />
          {newExtraName.trim() === "" && (
            <div className="form-text text-danger">
              Please enter a name for the new extra.
            </div>
          )}
          {extras?.some((extra) => extra.name.toLowerCase() === newExtraName.toLowerCase()) && (
            <div className="form-text text-warning">
              An extra with this name already exists.
            </div>
          )}
        </div>

      )}

      <div className="mb-3 d-flex gap-2">
        <div className="flex-fill">
          <label className="form-label">Amount</label>
          <input
            type="number"
            step="0.01"
            className="form-control"
            value={numUnits}
            onChange={(e) => setNumUnits(parseFloat(e.target.value) || 0)}
          />
        </div>
        <div className="flex-fill">
          <label className="form-label">Unit Price ($)</label>
          <input
            type="number"
            step="0.01"
            className="form-control"
            value={pricePerUnit}
            onChange={(e) => setPricePerUnit(parseFloat(e.target.value) || 0)}
          />
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">Amount ($)</label>
        <input
          type="number"
          className="form-control"
          value={newData.amount}
          readOnly
        />
      </div>

      <div className="mb-3 form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="paidCheckbox"
          checked={newData.paid === newData.amount && newData.amount > 0}
          onChange={(e) => onChange("paid", e.target.checked ? newData.amount : 0)}
        />
        <label className="form-check-label" htmlFor="paidCheckbox">
          Paid
        </label>
      </div>


      <div className="mb-3">
        <label className="form-label">Payment Type</label>
        <select
          className="form-select"
          value={newData.payment?.type || ""}
          onChange={(e) => onChange("type", e.target.value, true)}
        >
          <option value="">Select type</option>
          <option value="card">Card</option>
          <option value="cash">Cash</option>
          <option value="check">Check</option>
          <option value="other">Other</option>
        </select>
      </div>

      {newData?.payment && <ObjDisplay data={newData.payment} />}

      <div className="modal-btn-container">
        <button className="form-danger-btn btn" onClick={remove}>Delete</button>

        <div className="right-buttons">
          <button className="form-secondary-btn btn" onClick={reset}>Reset</button>
          <button className="form-primary-btn btn" onClick={submit}>Submit</button>
        </div>
      </div>
    </form>
  );
};

export default ExtraForm;
